// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1QBYe","consentsList":"PatientConsents_consentsList__2iWvF","consentsListEmpty":"PatientConsents_consentsListEmpty__hIrlZ"};